import {Brick} from "../brick/brick";
import {Plate} from "../plate/plate";
import {Ball} from "./ball";

export class Board {
  bricks: Brick[][] = [];
  cols = 12;
  rows = 20;
  plate = new Plate();
  ball = new Ball();
  delay = 50;
  timer: any;
  maxY = 1;

  constructor() {
    this.restart();
  }

  restart() {
    this.bricks = new Array(this.rows).fill(0)
      .map(() => new Array(this.cols).fill(0)
        .map(()=> new Brick()));
    this.plate.x = 0.5;
    this.setSpeed();
    this.maxY = this.rows / this.cols/ 2;
    this.plate.y = this.maxY - this.plate.height;
  }

  setSpeed() {
    if(this.timer) {
      clearInterval(this.timer);
    }
    this.timer = setInterval(() => this.move(), this.delay);
  }

  move() {
    this.plate.move();
    this.ball.move(this.maxY);
    const limitY = this.maxY - this.ball.r - this.plate.height;
    if(this.ball.y > limitY) {

      if(this.plate.inRange(this.ball))
      {
        this.plate.interact(this.ball);
      } else {
        // clearInterval(this.timer);
        console.log('died');
      }
    }
  }

  handleKey(key: string, amount = 1): boolean {
    switch(key) {
      case 'ArrowLeft': this.plate.speed -= 0.2*amount; break;
      case 'ArrowRight': this.plate.speed += 0.2*amount; break;
    }
    return true;
  }

}
